import React from "react";
import { useParams } from "react-router-dom";
import { Resume } from "../components";
import { DEFAULT_THEME, THEMES } from "../config";
import { useTheme } from "../hooks";
export var Presentation = function Presentation() {
  var _URL$searchParams$get;

  var _useParams = useParams(),
      resumeId = _useParams.resumeId;

  var theme = (_URL$searchParams$get = new URL(location.href).searchParams.get("theme")) !== null && _URL$searchParams$get !== void 0 ? _URL$searchParams$get : DEFAULT_THEME;
  useTheme(theme, THEMES);
  return /*#__PURE__*/React.createElement(Resume, {
    id: resumeId
  });
};